"use strict";
// Simplified normalized point definitions for letters (0-100 coordinate space)
// This is a "Basic" representation for the non-AI engine.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LETTER_PATHS = void 0;
exports.LETTER_PATHS = {
    'A': {
        char: 'A',
        strokes: [
            [{ x: 50, y: 10 }, { x: 20, y: 90 }], // Left diag
            [{ x: 50, y: 10 }, { x: 80, y: 90 }], // Right diag
            [{ x: 35, y: 60 }, { x: 65, y: 60 }] // Cross
        ]
    },
    'B': {
        char: 'B',
        strokes: [
            [{ x: 30, y: 10 }, { x: 30, y: 90 }], // Vertical
            [{ x: 30, y: 10 }, { x: 60, y: 10 }, { x: 70, y: 25 }, { x: 60, y: 45 }, { x: 30, y: 45 }], // Top loop
            [{ x: 30, y: 45 }, { x: 65, y: 45 }, { x: 80, y: 70 }, { x: 65, y: 90 }, { x: 30, y: 90 }] // Bottom loop
        ]
    },
    'C': {
        char: 'C',
        strokes: [
            [{ x: 80, y: 20 }, { x: 60, y: 10 }, { x: 30, y: 10 }, { x: 20, y: 30 }, { x: 20, y: 70 }, { x: 30, y: 90 }, { x: 60, y: 90 }, { x: 80, y: 80 }]
        ]
    }
};
